// Status change configurations
export const statusChangeConfig = {
  launch: {
    title: 'Launch Assessment',
    message: 'Are you sure you want to launch this assessment?',
    description: 'Once launched, the assessment will become active and accessible to patients. You can deactivate it later if needed.',
    confirmText: 'Launch Assessment',
    confirmButtonClass: 'launchButton',
  },
  deactivate: {
    title: 'Deactivate Assessment',
    message: 'Are you sure you want to deactivate this assessment?',
    description: 'The assessment will be temporarily disabled and patients won\'t be able to access it. No data will be lost and you can reactivate it anytime.',
    confirmText: 'Deactivate',
    confirmButtonClass: 'deactivateButton',
  },
  relaunch: {
    title: 'Reactivate Assessment',
    message: 'Are you sure you want to reactivate this assessment?',
    description: 'The assessment will become active again and accessible to patients. All previous data will remain intact.',
    confirmText: 'Reactivate',
    confirmButtonClass: 'launchButton',
  },
  archive: {
    step1: {
      title: 'Archive Assessment',
      message: 'Are you sure you want to archive this assessment?',
      description: 'The assessment will be moved to archive and hidden from the main list. All data will be preserved and you can unarchive it anytime.',
      confirmText: 'Continue',
      confirmButtonClass: 'launchButton',
    },
    step2: {
      title: 'Final Confirmation',
      message: 'This action will archive the assessment permanently',
      description: 'The assessment will be moved to the archive section and removed from the main view. While data is preserved, this action requires careful consideration.',
      confirmText: 'Archive Assessment',
      confirmButtonClass: 'deactivateButton',
    },
  },
  unarchive: {
    title: 'Unarchive Assessment',
    message: 'Are you sure you want to unarchive this assessment?',
    description: 'The assessment will be restored to inactive status and shown in the main list. All data will remain intact.',
    confirmText: 'Unarchive',
    confirmButtonClass: 'launchButton',
  },
};